import Avatar from "../Artifacts/Home/Avatar.svg";
import React, { useState, useEffect } from "react";
import { axInst } from "../Components/Login/Service";
import { RxCrossCircled } from "react-icons/rx";

const ProfileCard = ({ handleCloseModal }) => {
  const [userProfile, setUserProfile] = useState(null);

  const fetchUserProfile = async () => {
    try {
      const response = await axInst.get("user-profile");
      setUserProfile(response.data);
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  useEffect(() => {
    fetchUserProfile();

    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        handleCloseModal();
      }
    };

    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, []);

  const SkeletonLoader = () => (
    <div className="w-full">
      <div className="absolute top-[-10px] right-[-10px] ">
        <RxCrossCircled
          onClick={handleCloseModal}
          className="text-xl text-gray-700 bg-gray-100 rounded-full p-1 cursor-pointer hover:bg-gray-200"
        />
      </div>
      <div className="bg-cyan-600 py-4 text-center text-white text-xl font-semibold">
        Profile
      </div>
      <div className="w-96 flex flex-col items-center py-6 animate-pulse">
        <div className="w-24 h-24 bg-gray-300 rounded-full" />
        <div className="mt-4 h-5 w-40 bg-gray-300 rounded" />
        <div className="mt-2 h-4 w-24 bg-gray-200 rounded" />
      </div>
      <div className="px-6 pb-6 space-y-3 text-sm">
        {[1, 2, 3, 4].map((item) => (
          <div
            key={item}
            className="flex justify-between border-b pb-1 items-center"
          >
            <div className="h-4 w-24 bg-gray-300 rounded" />
            <div className="h-4 w-32 bg-gray-200 rounded" />
          </div>
        ))}
      </div>
    </div>
  );

  if (!userProfile) {
    return <SkeletonLoader />;
  }

  return (
    <div className="w-full">
      <div className="absolute top-[-10px] right-[-10px] ">
        <RxCrossCircled
          onClick={handleCloseModal}
          className="text-xl text-gray-700 bg-gray-100 rounded-full p-1 cursor-pointer hover:bg-gray-200"
        />
      </div>
      <div className="bg-cyan-600 py-4 text-center text-white text-xl font-semibold">
        Profile
      </div>
      <div className="w-96 flex flex-col items-center py-6">
        <div className="w-24 h-24 bg-cyan-100 rounded-full flex items-center justify-center text-4xl">
          <img src={Avatar} loading="lazy" alt="Profile" className="size-20" />
        </div>
        <h2 className="mt-4 text-xl font-bold">{userProfile.DISPLAY_NAME}</h2>
        <p className="text-gray-600">{userProfile.PRIMARY_POSITION_TYPE}</p>
      </div>
      <div className="px-6 pb-6 space-y-3 text-sm text-gray-700">
        <div className="flex justify-between border-b pb-1">
          <span className="font-medium">User ID</span>
          <span>{userProfile.USER_ID}</span>
        </div>
        <div className="flex justify-between border-b pb-1">
          <span className="font-medium">Email</span>
          <span>{userProfile.EMAIL_ADDR}</span>
        </div>
        <div className="flex justify-between border-b pb-1">
          <span className="font-medium">IP Address</span>
          <span>{userProfile.CLIENT_IP}</span>
        </div>
        <div className="flex justify-between border-b pb-1">
          <span className="font-medium">Position</span>
          <span>{userProfile.PRIMARY_POSITION_TYPE}</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
